import BaseService from '_services/rest/base';

class ManagerService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/manager`;
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(
      `${this.getUrl()}/all/${params.skip}/${params.take}`,
      filters,
    )
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getManagerById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(manager) {
    return this.request(`${this.getUrl()}/${manager.id}`, manager, 'PUT')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  delete(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE').catch(err => {
      throw err;
    });
  }

  getSupervisorDistributors(params) {
    const filters = { search: params.search, group: params.group };
    return this.request(
      `${this.getUrl()}/supervisors/${params.id}/${params.skip}/${
        params.take
      }`,
      filters
    )
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  syncResellers({ id, supervisors }) {
    return this.request(
      `${this.getUrl()}/supervisors/${id}`,
      { supervisors },
      'PUT'
    ).catch(err => {
      throw err;
    });
  }
}

export default new ManagerService();
